<script>
  import { seoUtils } from '$lib/utils/seo.js';
  import { page } from '$app/stores';
  
  export let title = '';
  export let description = '';
  export let keywords = '';
  export let canonicalUrl = '';
  export let image = 'https://spinwheelnames.com/images/og-image.png';
  export let type = 'website';
  export let structuredData = null;
  export let noIndex = false;
  export let noFollow = false;
  
  // Generate SEO data using utilities if not provided
  $: seoData = seoUtils.generatePageSEO({
    title: title || 'Free Random Name Picker Wheel | SpinWheelNames',
    description: description || 'Free online random name picker wheel for classrooms, contests, and decision making. No login required - just add names and spin!',
    keywords: keywords || 'random name picker, wheel spinner, name picker wheel, classroom tool, contest winner',
    path: $page.url.pathname,
    lang: $page.url.searchParams.get('lang') || 'en'
  });
  
  // Use provided canonical URL or generate one with validation
  $: finalCanonicalUrl = canonicalUrl ? 
    seoUtils.validateCanonicalUrl(canonicalUrl) : 
    seoUtils.validateCanonicalUrl(seoData.canonicalUrl);
  
  // Generate robots content
  $: robotsContent = [
    noIndex ? 'noindex' : 'index',
    noFollow ? 'nofollow' : 'follow'
  ].join(', ');
  
  // Use provided values or fall back to generated ones
  $: finalTitle = title || seoData.title;
  $: finalDescription = description || seoData.description;
  $: finalKeywords = keywords || seoData.keywords;
</script>

<svelte:head>
  <!-- Primary Meta Tags -->
  <title>{finalTitle}</title>
  <meta name="description" content={finalDescription} />
  {#if finalKeywords}
    <meta name="keywords" content={finalKeywords} />
  {/if}
  <meta name="robots" content={robotsContent} />
  <meta name="author" content="SpinWheelNames" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  
  <!-- Canonical URL -->
  <link rel="canonical" href={finalCanonicalUrl} />
  
  <!-- Open Graph / Facebook -->
  <meta property="og:type" content={type} />
  <meta property="og:title" content={finalTitle} />
  <meta property="og:description" content={finalDescription} />
  <meta property="og:image" content={image} />
  <meta property="og:site_name" content="SpinWheelNames" />
  <meta property="og:url" content={finalCanonicalUrl} />
  
  <!-- Twitter -->
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content={finalTitle} />
  <meta name="twitter:description" content={finalDescription} />
  <meta name="twitter:image" content={image} />
  <meta name="twitter:site" content="@spinwheelnames" />
  
  <!-- Additional Meta Tags -->
  <meta name="theme-color" content="#4caf50" />
  <meta name="msapplication-TileColor" content="#4caf50" />
  
  <!-- Structured Data with validation -->
  {#if structuredData}
    {#if seoUtils.validateStructuredData(structuredData)}
      {@html `<script type="application/ld+json">${JSON.stringify(structuredData)}</script>`}
    {:else}
      <!-- Log validation error but don't break the page -->
      {console.warn('Invalid structured data:', structuredData)}
    {/if}
  {/if}
</svelte:head>